export enum Endpoints {
  ACTIVITY_LIST = '/public/product-activities',
  CHANNEL = 'public/channels/{key}',
  SOURCES = 'public/sources',
  CUSTOMER = 'customer',
  FORGOTTEN_PASSWORD = 'customer/password/remind',
  PASSWORD_RESET = 'customer/password/reset',
  CONTENT_LIST = 'public/contents',
  PUBLIC_LIST = 'public/list',
  POLICY_APPLICATIONS = 'public/applications',
  POLICY_APPLICATION = 'public/applications/{id}',
  POLICY_APPLICATION_ISSUE = 'public/applications/{id}:issue',
  POLICY_APPLICATION_PAY = 'public/applications/{id}:pay',
  POLICY_DOCUMENTS_POLL = 'public/policy:documents-poll',
  DESTINATIONS = 'public/product-destinations',
  INDUSTRIES = 'public/product-industries',
  OCCUPATIONS = 'public/product-occupations',
  SCREENING_START_CEGA = 'public/medical/cega:start',
  SCREENING_FINISH_CEGA = 'public/medical/cega:finish',
  SCREENING_START_HEALIX = 'public/medical/healix:start',
  SCREENING_FINISH_HEALIX = 'public/medical/healix:finish',
  POSTCODE_LOOKUP = 'public/postcode/{postcode}',
  POSTCODE_GET = 'public/address/{id}',
  TRANSACTION_PAY = 'public/transactions/{id}:pay',
  AGGREGATOR_POLICY_APPLICATION = 'aggregators/{id}',
  CAMPAIGN_CODE = '/public/campaigns/code/{code}',
  TRACKING_LINKS = 'public/tracking-links/{id}',
  REFERRAL_QUOTE = 'public/applications/{id}:refer',
  GET_SIGNPOST = 'public/contents/signpost',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/endpoints.ts